(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-essential-home]').forEach(home => {
      if (home.dataset.essentialReady) return;
      const pack = home.querySelector('[data-home-pack]'), composer = pack?.querySelector('[data-dizane-bundles]');
      const solo = home.querySelector('[data-home-solo]'), modes = home.querySelector('[data-home-modes]'), single = home.querySelector('[data-home-solo-toggle]');
      if (!composer || !solo || !modes || !single) return;
      let info, needs;
      try {
        info = JSON.parse(composer.querySelector('[data-bundle-config]').textContent);
        needs = JSON.parse(home.querySelector('[data-home-needs-config]')?.textContent || '[]');
      } catch { return; }
      if (!Array.isArray(info.variants) || !Array.isArray(needs)) return;
      if (!needs.length) needs = [{key:'sommeil',handle:'nuit-paisible',product:'Nuit Paisible'}];
      home.dataset.essentialReady = 'true';
      const region = home.closest('.shopify-section') || home.parentElement;
      const choices = [...composer.querySelectorAll('[data-bundle-choice]')], offers = [...modes.querySelectorAll('[data-home-offer]')];
      const tabs = [...home.querySelectorAll('[data-home-need]')], value = home.querySelector('[data-home-value]');
      const four = home.querySelector('[data-home-four]'), gift = home.querySelector('[data-home-gift]');
      const money = cents => new Intl.NumberFormat(info.locale || 'fr-FR', {style:'currency',currency:info.currency}).format(cents / 100);
      const readKey = () => {
        const key = new URL(window.location.href).searchParams.get('besoin');
        return needs.some(n => n.key === key) ? key : 'sommeil';
      };
      let need = needs.find(n => n.key === readKey()) || needs[0];
      let mode = Number(home.dataset.initialOffer) === 4 ? 4 : 3, ready = false, startQueued = false, busy = false;
      const selectedVariant = () => info.variants.find(v => v.handle === need.handle && v.available) || info.variants.find(v => v.handle === need.handle);
      const presetHandles = size => size < 4 ? Array(size).fill(need.handle) : [need.handle, ...['nuit-paisible','digestion','relax','energy'].filter(h => h !== need.handle)];
      const setText = (selector, text) => { if (text) region.querySelectorAll(selector).forEach(node => { node.textContent = text; }); };
      const updateURL = method => {
        const url = new URL(window.location.href);
        url.searchParams.set('besoin', need.key);
        window.history[method](window.history.state, '', url);
      };
      const updateNeed = () => {
        const variant = selectedVariant();
        tabs.forEach(tab => {
          const active = tab.dataset.homeNeed === need.key;
          tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
        });
        const activeTab = tabs.find(tab => tab.dataset.homeNeed === need.key);
        if (activeTab) home.querySelector('[data-need-panel]')?.setAttribute('aria-labelledby', activeTab.id);
        home.dataset.activeNeed = need.key;
        setText('[data-need-title]', need.title); setText('[data-need-product]', need.product);
        setText('[data-need-offer-title]', '3 ' + need.product); setText('[data-need-offer-tag]', need.tag);
        setText('[data-need-moment]', need.moment); setText('[data-need-taste]', need.taste);
        region.querySelectorAll('[data-need-product-link]').forEach(link => {
          if (need.url) {
            const target = new URL(need.url, window.location.origin);
            const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
            if (preview) target.searchParams.set('preview_theme_id', preview);
            link.href = target.href;
          }
          link.textContent = 'Découvrir ' + need.product + ' : plantes et usage →';
        });
        const picture = home.querySelector('[data-need-picture]');
        if (picture && need.image && picture.dataset.activeImage !== need.image) {
          const img = picture.querySelector('img');
          if (img) { img.removeAttribute('srcset'); img.src = need.image; img.alt = need.product + ' : votre tisane bio à diluer'; }
          const source = picture.querySelector('source');
          if (source) source.srcset = need.mobileImage || need.image;
          picture.dataset.activeImage = need.image;
        }
        const soloId = solo.querySelector('input[name="id"]');
        if (soloId) soloId.value = variant ? String(variant.id) : '';
        const soloButton = solo.querySelector('button[type="submit"],button');
        if (soloButton) {
          soloButton.disabled = !variant?.available || busy;
          soloButton.textContent = variant?.available ? 'Ajouter 1 ' + need.product + ' — ' + money(variant.price) : 'Momentanément indisponible';
        }
        const duoPrice = home.querySelector('[data-need-duo-price]');
        if (duoPrice) duoPrice.textContent = variant?.available && variant.price === 1990 && info.currency === 'EUR' ? money(3582) : 'Au panier';
        const offerPrice = home.querySelector('[data-need-offer-price]');
        if (offerPrice) {
          offerPrice.replaceChildren();
          const verified = variant?.available && variant.price === 1990 && info.currency === 'EUR';
          offerPrice.append(document.createTextNode(verified ? money(4896) : 'Au panier'));
        }
        setText('[data-need-solo-price]', variant ? money(variant.price) : 'Indisponible');
        offers.forEach(button => { button.disabled = busy || ([1,2,3].includes(Number(button.dataset.homeOffer)) && !variant?.available); });
        single.hidden = Boolean(home.querySelector('[data-home-offer="1"]')) || !variant?.available; single.disabled = busy;
        single.textContent = mode === 1 ? 'Revenir au lot de 3' : 'Commencer avec 1 flacon · ' + money(variant?.price || 0);
        if (need.title) document.title = 'Dizane — La tisane sans infusion';
      };
      const updatePlan = detail => {
        const size = detail.size, selected = choices.slice(0, size).map(select => info.variants.find(v => String(v.id) === select.value));
        const matchesPreset = detail.valid && (size < 4
          ? selected.length === size && selected.every(v => v?.handle === need.handle)
          : size === 4 && presetHandles(4).every(handle => selected.filter(v => v?.handle === handle).length === 1));
        offers.forEach(button => button.setAttribute('aria-pressed', String(mode === 1 ? Number(button.dataset.homeOffer) === 1 : Number(button.dataset.homeOffer) === size)));
        if (four) four.hidden = size !== 4 || !matchesPreset;
        if (gift) {
          gift.hidden = !detail.valid || size !== 4 || gift.hasAttribute('data-gift-unavailable');
          const perks = pack.querySelector('.de-perks'); if (perks) perks.hidden = !detail.valid || size < 3;
        }
        const composition = home.querySelector('[data-home-composition]');
        if (composition) composition.textContent = matchesPreset ? (size === 4 ? '100 boissons à découvrir, à savourer, à partager.' : size + ' flacons de ' + need.product + ', à ouvrir au fur et à mesure.') : selected.filter(Boolean).map(v => v.title.replace(/^Dizane\s+/i, '')).join(' · ');
        const upgrade = home.querySelector('[data-home-upgrade]');
        if (upgrade) upgrade.hidden = !(size === 4 && matchesPreset && detail.confirmedPrice === 5972 && selectedVariant()?.price === 1990 && info.currency === 'EUR');
        const discovery = size === 4 && matchesPreset && mode !== 1;
        const customize = composer.querySelector('.de-customize');
        if (customize) customize.hidden = discovery;
        const selection = home.querySelector('[data-discovery-selection]');
        if (selection) selection.textContent = discovery ? 'Pack sélectionné' : 'Choisir le Pack Découverte';
        if (discovery && !detail.locked) {
          composer.querySelector('[data-bundle-submit]').textContent = 'Ajouter le Pack Découverte' + (typeof detail.confirmedPrice === 'number' ? ' — ' + money(detail.confirmedPrice) : ' au panier');
        }
        if (!value) return;
        if (!detail.valid) { value.textContent = 'Complétez votre sélection.'; return; }
        const verified = typeof detail.confirmedPrice === 'number' && Number.isFinite(detail.confirmedPrice);
        value.textContent = verified ? size * 25 + ' boissons · ' + money(detail.confirmedPrice / (size * 25)) + ' / boisson à 10 ml' : size * 25 + ' boissons à 10 ml · montant au panier';
      };
      const show = size => {
        if (busy || ![1,2,3,4].includes(size) || ([2,3].includes(size) && !selectedVariant()?.available)) return false;
        mode = size;
        const discoveryCard = home.querySelector('[data-home-offer="4"]');
        if (size === 4) {
          modes.after(pack);
          pack.after(solo);
        } else {
          modes.insertBefore(size === 1 ? solo : pack, discoveryCard);
        }
        home.dataset.selectedOffer = String(size); pack.hidden = size === 1; solo.hidden = size !== 1;
        offers.forEach(button => button.setAttribute('aria-pressed', String(size === 1 && Number(button.dataset.homeOffer) === 1)));
        updateNeed();
        if (size === 1) {
          const selection = home.querySelector('[data-discovery-selection]');
          if (selection) selection.textContent = 'Choisir le Pack Découverte';
          return true;
        }
        const detail = {size, handle:need.handle};
        composer.dispatchEvent(new CustomEvent('dizane:bundle:preset', {cancelable:true, detail}));
        // Keep the native selectors usable if an older composer is cached.
        if (detail.accepted === undefined) {
          const handles = presetHandles(size);
          choices.forEach((select,index) => {
            const variant = info.variants.find(v => v.handle === handles[index] && v.available);
            select.value = variant ? String(variant.id) : '';
          });
          const radio = composer.querySelector('[data-bundle-size][value="' + size + '"]');
          if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change',{bubbles:true})); }
        }
        return detail.accepted !== false;
      };
      const changeNeed = (key, historyMethod) => {
        const next = needs.find(n => n.key === key);
        if (busy || !next) return false;
        need = next;
        show(selectedVariant()?.available ? mode : 1);
        if (historyMethod) updateURL(historyMethod);
        home.dispatchEvent(new CustomEvent('dizane:need:change', {bubbles:true, detail:{need:need.key,handle:need.handle,size:mode}}));
        return true;
      };
      const start = () => {
        if (ready || startQueued || !composer.dataset.bundleReady) return;
        startQueued = true;
        queueMicrotask(() => {
          startQueued = false;
          if (ready || !composer.dataset.bundleReady) return;
          ready = true; modes.hidden = false; updateNeed();
          const allFourAvailable = presetHandles(4).every(handle => info.variants.some(v => v.handle === handle && v.available));
          show(mode === 4 && allFourAvailable ? 4 : selectedVariant()?.available ? 3 : 1);
        });
      };
      composer.addEventListener('dizane:bundle:change', event => {
        busy = Boolean(event.detail.locked);
        offers.forEach(button => { button.disabled = busy || ([1,2,3].includes(Number(button.dataset.homeOffer)) && !selectedVariant()?.available); });
        tabs.forEach(tab => { tab.disabled = busy; }); single.disabled = busy;
        composer.dataset.planValid = String(event.detail.valid);
        const customize = composer.querySelector('.de-customize');
        if (!event.detail.valid && customize) customize.open = true;
        updatePlan(event.detail); start();
      });
      tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => { if (tab.dataset.homeNeed !== need.key) changeNeed(tab.dataset.homeNeed, 'pushState'); });
        tab.addEventListener('keydown', event => {
          if (busy || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
          if (tabs[nextIndex].dataset.homeNeed !== need.key) changeNeed(tabs[nextIndex].dataset.homeNeed, 'pushState');
        });
      });
      window.addEventListener('popstate', () => { if (!home.isConnected) return; if (!changeNeed(readKey())) updateURL('replaceState'); });
      offers.forEach(button => button.addEventListener('click', () => show(Number(button.dataset.homeOffer))));
      document.querySelectorAll('a[href$="#pack-decouverte"]').forEach(link => {
        link.addEventListener('click', () => { if (home.isConnected) show(4); });
      });
      single.addEventListener('click', () => show(mode === 1 ? 3 : 1));
      start();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();